import classnames from 'classnames';
import config from 'config';
import { fromPairs, isUndefined, some } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Fragment } from 'redux-little-router';
import { routeMap } from 'router';
import Storage from 'services/Storage';
import AuthorizationPageContainer from '../../../Authorization/containers/AuthorizationPageContainer';
import AccessibilityContainer from '../../containers/AccessibilityContainer';
import InactivityTimerContainer from '../../containers/InactivityTimerContainer';
import ContentWrapperContainer from '../../containers/ContentWrapperContainer';
import EmailConfirmationContainer from '../../containers/EmailConfirmationContainer';
import FeedbackContainer from '../../containers/FeedbackContainer';
import InfoPageContainer from '../../containers/InfoPageContainer';
import Faq from '../Faq';
import { updateData } from '../../services/API';
import ErrorLoadingData from '../ErrorLoadingDataModal';
import ChatBot from '../ChatBot';
import './style.scss';
import TaxpayerCsvInfo from '../TaxpayerCsvInfo';
import styles from 'modules/App/components/App/accessibilityThemeProvider.module.scss';
import ExternalAppointment from 'modules/App/components/ExternalAppointment/ExternalAppointment';
import { remotePaths } from 'router/routes';
import { FileUploadModal } from 'components/File/private/FileUploadModal';
import { fileService } from 'services/fileService';
import 'react-toastify/dist/ReactToastify.css';
import { ToastsContainer } from 'modules/Toasts';
import NotificationsSidebar from 'modules/Notifications/components/NotificationsSidebar';
import REACT_CONFIG from 'REACT_CONFIG';
import ModalInit from './ModalInit';
import { ConfigWrapper } from '../../../ConfigWrapper';
import AppIsReadyCheckWrapper from '../../../AppIsReadyCheckWrapper';

export default class App extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
    setIncomingData: PropTypes.func.isRequired,
    clearQueryString: PropTypes.func.isRequired,
    goToInfoPage: PropTypes.func.isRequired,
    goToHome: PropTypes.func.isRequired,
    showAccessibilityModal: PropTypes.func.isRequired,
    loadModalConfig: PropTypes.func,
    loadRefConfig: PropTypes.func,
    isShowTour: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
  };

  static isNotLoginPage(loc) {
    return loc.route !== routeMap.login || config.isInspectorArm;
  }

  static isFaqPage(loc) {
    return loc.route === routeMap.faq;
  }

  static isExternalAppointment(loc) {
    return (
      loc.route === routeMap.externalAppointment &&
      !Storage.getItem(config.tokenItemName) &&
      !REACT_CONFIG.REACT_APP_HIDE_EXTERNAL_APPOINTMENT
    );
  }

  static isFaqServicesPage(loc) {
    return loc.route === routeMap.faqServices;
  }

  state = {
    hasInn: this.props.router.query.hasInn,
    fidProcessed: this.props.router.query.fidProcessed,
    unconfirmed: this.props.router.query.unconfirmed,
    accessToken: this.props.router.query.access_token,
    email: this.props.router.query.email,
    showLoadDataSuccessMessage: false,
    isUserLoggedIn: localStorage.getItem(config.tokenItemName),
  };

  fileModal = React.createRef();

  componentDidMount() {
    fileService.init(this.fileModal);
    const { router, setIncomingData, clearQueryString, goToInfoPage } = this.props;
    const email = router.query.email;
    const checkEmail = router.query.checkEmail ? router.query.checkEmail === 'true' : null;
    const resetPassword = router.query.changePassword
      ? router.query.changePassword === 'true'
      : null;
    let accessToken = router.query.access_token;
    const token = router.query.token;

    // this.props.loadModalConfig();
    this.props.loadRefConfig();

    if (!accessToken && router.hash) {
      const hash = this.parseExternalHash(router.hash);

      accessToken = hash.access_token;
    }

    if (email) {
      setIncomingData({ email, checkEmail });
    }

    if (resetPassword) {
      setIncomingData({ resetPassword, token });
      clearQueryString();
    }

    if (accessToken) {
      Storage.setItem(config.tokenItemName, accessToken);
      this.setState({ isUserLoggedIn: accessToken });
      clearQueryString();
    }

    if (this.isInfoPage()) {
      goToInfoPage(router.query);
    }
  }

  parseExternalHash = (hash = '') => {
    hash = hash.replace(/^#/, '');
    const items = hash.split('&');

    return fromPairs(items.map((option) => option.split('=')));
  };

  updateUserData = (e) => {
    e.preventDefault();
    updateData().then(() => {
      this.setState({
        showLoadDataSuccessMessage: true,
      });
    });
  };

  handleLoadDataSuccessCloseClick = () => this.setState({ showLoadDataSuccessMessage: false });

  demoRedirect = () => {
    if (config.isDemoMode) {
      Storage.setItem(config.tokenItemName, 'demo-mode');
      this.props.goToHome();
      return false;
    }
    return true;
  };

  isInfoPage() {
    const {
      router: { query },
    } = this.props;
    const {
      hasInn,
      fidProcessed,
      unconfirmed,
      access_token: accessToken,
      esiaError,
      unauthorized,
    } = query;
    const allowedQueryParams = [hasInn, fidProcessed, unconfirmed, esiaError, unauthorized];
    return some(allowedQueryParams, (param) => !isUndefined(param)) && !accessToken;
  }

  isHomePage(loc) {
    return (
      App.isNotLoginPage(loc) &&
      !this.isInfoPage() &&
      !App.isFaqPage(loc) &&
      !App.isExternalAppointment(loc) &&
      !App.isFaqServicesPage(loc)
    );
  }

  renderFrame() {
    return (
      <div>
        <div className="view-item view-item_top">
          <div className="content">
            <div className="cRow">
              <div className="cCol">
                <span className="mobile-hide">Вы находитесь в режиме просмотра</span>
                <span className="mobile-show">Режим просмотра</span>
              </div>
              <div className="cCol">
                <TaxpayerCsvInfo />
              </div>
              <div className="cCol cCol__right">
                <a href={remotePaths.taxpayerSearching} className="link link_close">
                  <span className="mobile-hide">Вернуться к поиску</span>
                </a>
              </div>

              <div className="cCol cCol__right">
                <a href="" className="link link_refresh" onClick={this.updateUserData}>
                  <span className="mobile-hide">Обновить</span>
                </a>
              </div>
            </div>
            {this.state.showLoadDataSuccessMessage ? (
              <div className="cRow load-user-data-success">
                <div className="cCol">
                  <span>
                    Запрос на загрузку данных пользователя добавлен в очередь. Новые данные будут
                    отображены сразу после загрузки
                  </span>
                </div>
                <div className="cCol cCol__right cCol">
                  <a onClick={this.handleLoadDataSuccessCloseClick} className="link link_close">
                    Закрыть
                  </a>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="view-item view-item_right" />
        <div className="view-item view-item_left" />
        <div className="view-item view-item_bottom" />
      </div>
    );
  }

  renderHomepage() {
    return (
      <ConfigWrapper>
        {config.enableNotificationsCenter && <NotificationsSidebar />}
        <ContentWrapperContainer />
      </ConfigWrapper>
    );
  }

  render() {
    const { isShowTour } = this.props;
    const { isUserLoggedIn } = this.state;
    return (
      <div
        id="scroll-wrapper"
        className={classnames('scroll-wrapper', styles.themeProvider, {
          view: config.isInspectorArm,
          'view__success-message': this.state.showLoadDataSuccessMessage,
        })}
      >
        {config.isInspectorArm ? this.renderFrame() : null}
        <FileUploadModal ref={this.fileModal} />
        <ErrorLoadingData />

        <EmailConfirmationContainer />
        <Fragment
          forRoute={routeMap.login}
          withConditions={(loc) =>
            !this.isInfoPage() &&
            !App.isFaqPage(loc) &&
            !App.isExternalAppointment(loc) &&
            !App.isFaqServicesPage(loc) &&
            this.demoRedirect() &&
            !config.isInspectorArm
          }
        >
          <AuthorizationPageContainer />
        </Fragment>
        <Fragment forRoute={routeMap.home} withConditions={(loc) => this.isHomePage(loc)}>
          {isUserLoggedIn || this.props.isLoggedIn ? (
            <AppIsReadyCheckWrapper>{this.renderHomepage()}</AppIsReadyCheckWrapper>
          ) : (
            this.renderHomepage()
          )}
        </Fragment>
        <Fragment forRoute={routeMap.faq} withConditions={(loc) => !this.isHomePage(loc)}>
          <Faq showAccessibilityModal={this.props.showAccessibilityModal} />
        </Fragment>
        <Fragment forRoute={routeMap.info} withConditions={(loc) => !this.isHomePage(loc)}>
          <InfoPageContainer />
        </Fragment>
        <Fragment
          forRoute={routeMap.externalAppointment}
          withConditions={(loc) =>
            !this.isHomePage(loc) && !REACT_CONFIG.REACT_APP_HIDE_EXTERNAL_APPOINTMENT
          }
        >
          <ExternalAppointment />
        </Fragment>
        <FeedbackContainer />
        <AccessibilityContainer />
        <InactivityTimerContainer />
        <ToastsContainer />
        <ModalInit />
        {config.chatBotUrl && !isShowTour && isUserLoggedIn && <ChatBot />}
      </div>
    );
  }
}
